const admin = ['ROLE_ADMIN'];
const analistaAgnes = ['ROLE_ANALISTA_AGNES', 'ROLE_ADMIN'];
const terceirosListagem = ['ROLE_MENU_GDT_LISTAGEM', 'ROLE_ACTION_GDT_LISTAGEM_EDICAO', 'ROLE_ADMIN'];
const terceirosListagemEdicao = ['ROLE_ACTION_GDT_LISTAGEM_EDICAO', 'ROLE_ADMIN'];
const terceirosEncargos = ['ROLE_MENU_GDT_ENCARGOS', 'ROLE_ADMIN'];
const terceirosFolhaPagamento = ['ROLE_MENU_GDT_FOLHA_PAGTO', 'ROLE_ADMIN'];
const terceirosListagemCertidoes = [
  'ROLE_ACTION_GDT_LISTAGEM_CERTIDOES',
  'ROLE_ADMIN',
  'ROLE_ACTION_GDT_GERENCIAMENTO_CERTIDOES',
];
const terceirosGerenciamentoCertidoes = ['ROLE_ACTION_GDT_GERENCIAMENTO_CERTIDOES', 'ROLE_ADMIN'];
const terceirosListagemTrabalhoAnalogo = [
  'ROLE_ADMIN',
  'ROLE_ACTION_GDT_LISTAGEM_TRABALHO_ANALOGO',
  'ROLE_ACTION_GDT_GERENCIAMENTO_TRABALHO_ANALOGO',
];
const terceirosGerenciamentoTrabalhoAnalogo = ['ROLE_ACTION_GDT_GERENCIAMENTO_TRABALHO_ANALOGO', 'ROLE_ADMIN'];
const terceirosListagemTrabalharAlocado = ['ROLE_ACTION_GDT_LISTAGEM_TRABALHADORES_ALOCADOS', 'ROLE_ADMIN'];
const terceirosEnvioDocumentosVisualizacao = ['ROLE_MENU_GDT_ENVIO_VISUALIZACAO', 'ROLE_ADMIN'];
const terceirosSolicitacaoVisualizacao = ['ROLE_MENU_GDT_SOLICITACAO_VISUALIZACAO', 'ROLE_ADMIN'];
const terceirosSolicitacaoGerenciamento = ['ROLE_MENU_GDT_SOLICITACAO_GERENCIAMENTO', 'ROLE_ADMIN'];
const terceirosEnvioDocumentoGerenciamento = ['ROLE_MENU_GDT_ENVIO_GERENCIAMENTO', 'ROLE_ADMIN'];
const terceirosListagemMonitoramento = ['ROLE_ACTION_GDT_LISTAGEM_MONITORAMENTO', 'ROLE_ADMIN'];
const terceirosListagemControleValidade = ['ROLE_ACTION_GDT_LISTAGEM_VALIDADE', 'ROLE_ADMIN'];
const terceirosMenuAreaAtuacao = ['ROLE_MENU_GDT_AREA_DE_ATIVIDADE', 'ROLE_ADMIN'];
const terceirosMenuLinhasDeServico = ['ROLE_MENU_GDT_LINHAS_SERVICO', 'ROLE_ADMIN'];
const terceirosMenuTiposDeDocumentos = ['ROLE_MENU_GDT_TIPOS_DOCUMENTOS', 'ROLE_ADMIN'];
const cnoVisualizacao = ['ROLE_ACTION_GDT_CNO_VISUALIZACAO', 'ROLE_ACTION_GDT_CNO_EDICAO', 'ROLE_ADMIN'];
const cnoEdicao = ['ROLE_ACTION_GDT_CNO_EDICAO', 'ROLE_ADMIN'];
const subcontratacaoVisualizacao = [
  'ROLE_ACTION_GDT_SUBCONTRATACAO_VISUALIZACAO',
  'ROLE_ACTION_GDT_SUBCONTRATACAO_EDICAO',
  'ROLE_ADMIN',
];
const subcontratacaoEdicao = ['ROLE_ACTION_GDT_SUBCONTRATACAO_EDICAO', 'ROLE_ADMIN'];
const notificacoesListagem = ['ROLE_MENU_GDT_NOTIFICACOES', 'ROLE_ADMIN'];
const notificacoesGerenciamento = ['ROLE_ACTION_GDT_GERENCIAMENTO_NOTIFICACOES', 'ROLE_ADMIN'];
const notificacoesCategoriasListagem = ['ROLE_ACTION_GDT_LISTAGEM_CATEGORIAS', 'ROLE_ADMIN'];
const notificacoesCategoriasGerenciamento = ['ROLE_ACTION_GDT_GERENCIAMENTO_CATEGORIAS', 'ROLE_ADMIN'];
const notificacoesAgendamentoAutomatico = ['ROLE_ACTION_GDT_GERENCIAMENTO_AGENDAMENTO_AUTOMATICO', 'ROLE_ADMIN'];

const MENU_ROLES = {
  admin,
  analistaAgnes,
  terceirosListagem,
  terceirosListagemEdicao,
  terceirosEncargos,
  terceirosFolhaPagamento,
  terceirosListagemCertidoes,
  terceirosGerenciamentoCertidoes,
  terceirosListagemTrabalhoAnalogo,
  terceirosGerenciamentoTrabalhoAnalogo,
  terceirosListagemTrabalharAlocado,
  terceirosEnvioDocumentoGerenciamento,
  terceirosSolicitacaoVisualizacao,
  terceirosSolicitacaoGerenciamento,
  terceirosEnvioDocumentosVisualizacao,
  terceirosListagemMonitoramento,
  terceirosListagemControleValidade,
  terceirosMenuAreaAtuacao,
  terceirosMenuLinhasDeServico,
  terceirosMenuTiposDeDocumentos,
  cnoVisualizacao,
  cnoEdicao,
  subcontratacaoVisualizacao,
  subcontratacaoEdicao,
  notificacoesListagem,
  notificacoesGerenciamento,
  notificacoesCategoriasListagem,
  notificacoesCategoriasGerenciamento,
  notificacoesAgendamentoAutomatico,
};

export default MENU_ROLES;
